import React from 'react';

import ImageBlurFallback from '../../Components/ImageBlurFallback';

import SALARY_IMAGE from '../../Assets/v2/liveClasses/salary.png';

import { CLIENT_URL_IMAGE } from '../../config.local';

// const defaultScopes = [
//   'Data Architect',
//   'Data Scientist',
//   'Data Mining Specialist',
//   'Statistician',
//   'Big Data Engineer',
//   'Cloud Architect',
//   'Cyber Security Analyst'
// ];

const ScopeItem = ({ text }) => {
  return (
    <li className="scope-container">
      <div className="scope-checkbox">
        <i className="fas fa-check "></i>
      </div>
      <span className="scope-description">{text}</span>
    </li>
  );
};
const Salary = ({ sallary, scopes, courseTitle, salaryGraphUrl }) => {
  const newScopes = Array.isArray(scopes) && scopes.length > 0 ? scopes : [];
  return sallary || (Array.isArray(scopes) && scopes.length > 0) ? (
    <section className="salary-container">
      <p className="salary-heading-text">Salary and Career Scope</p>
      <div className="salary-content">
        {Boolean(sallary) && (
          <div
            className={`salary-content-${
              newScopes.length > 0 ? 'left' : 'center'
            }`}>
            <div>
              <p className="salary-content-left-title1">Average Base Pay</p>
              <span className="salary-content-left-title2">{`INR ${sallary ||
                0}/yr`}</span>
            </div>
            <ImageBlurFallback
              className="salary-image"
              src={
                salaryGraphUrl
                  ? `${CLIENT_URL_IMAGE}${salaryGraphUrl}`
                  : SALARY_IMAGE
              }
              alt="salary"
            />
            <div className="salary-bar" />
          </div>
        )}

        {newScopes.length > 0 && (
          <div className="salary-content-right">
            <p className="salary-content-right-title">{`Brilliant Future Scopes of ${courseTitle}`}</p>
            <ul className="scope-list">
              {newScopes.map(scope => {
                return <ScopeItem key={scope} text={scope} />;
              })}
            </ul>
          </div>
        )}
      </div>
    </section>
  ) : null;
};

export default Salary;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Salary.js